module.exports = __webpack_public_path__ + "img/slide-17-5.f8b69529.png";